/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Container, Divider, FlexContainer, Icon, Text } from "@carrotfertility/carotene"
import { MainLayout } from "components/views/app/domainIsolation/MainLayout"
import { ContentfulConditionalGate } from "lib/contentful/components/ContentfulConditionGate"
import { ExpertBioProps } from "./ExpertBioParser"
import { Link, useHistory } from "react-router-dom"
import { ExpertBio } from "components/read/shared/ExpertBioMapper"
import { useIntl } from "react-intl"
import { Box } from "@carrotfertility/carotene-core"
import { ContentfulRawMarkdownRenderer } from "services/contentful"
import { defaultMarkdownElements } from "services/markdown"

type PreviousPage = {
  path: string
  title: string
}

const ExpertHeader = ({
  previousPageRoute,
  previousPageTitle
}: {
  previousPageRoute: string
  previousPageTitle: string
}): JSX.Element => {
  return (
    <Container>
      <Link to={previousPageRoute}>
        <FlexContainer direction="row" alignItems="center" style={{ paddingBottom: "8px" }}>
          <Container style={{ transform: "rotate(-90deg)", marginRight: "11px" }}>
            <Icon name="up" size="tiny" color="carrotOrange" />
          </Container>
          <Text weight="semibold" size="14px">
            {previousPageTitle}
          </Text>
        </FlexContainer>
      </Link>
      <Divider sx={{ width: "100%" }} color="lightGrey" />
    </Container>
  )
}

const ExpertOverview = ({ credentials, name }: { credentials: string; name: string }): JSX.Element => (
  <>
    <defaultMarkdownElements.h1.component {...defaultMarkdownElements.h1.props} variant="body2">
      {credentials}
    </defaultMarkdownElements.h1.component>
    <defaultMarkdownElements.h1.component {...defaultMarkdownElements.h1.props}>
      {name}
    </defaultMarkdownElements.h1.component>
  </>
)

const ExpertDetails = ({ expert }: { expert: ExpertBio }): JSX.Element => {
  const { credentials, name, description } = expert
  return (
    <Box width={{ xs: "unset", md: "600px" }}>
      <ExpertOverview credentials={credentials} name={name} />
      <ContentfulRawMarkdownRenderer>{description}</ContentfulRawMarkdownRenderer>
    </Box>
  )
}

const ExpertBioProfilePage = ({ expertBio }: ExpertBioProps): JSX.Element => {
  const intl = useIntl()
  const history = useHistory()
  const { path = "/read", title = intl.formatMessage({ defaultMessage: "Read & learn" }) } =
    (history.location.state as PreviousPage) || {}
  const expertSlugId = `${expertBio.slug}-${expertBio.id}`
  return (
    <MainLayout>
      <ContentfulConditionalGate conditions={expertBio?.conditions}>
        <Box
          display="flex"
          gap={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}
          flexDirection="column"
          data-expert-id={expertSlugId}
        >
          <ExpertHeader previousPageRoute={path} previousPageTitle={title} />
          <Container>
            <Box
              component="img"
              src={expertBio?.headshot?.file?.url}
              alt={intl.formatMessage({ defaultMessage: "Headshot of {expertName}" }, { expertName: expertBio?.name })}
              height="80px"
              width="80px"
              sx={{
                marginBottom: (theme) => theme.spacing(theme.tokens.spacing.lg),
                borderRadius: (theme) => theme.tokens.borderRadius.md
              }}
            />
            <ExpertDetails expert={expertBio} />
          </Container>
        </Box>
      </ContentfulConditionalGate>
    </MainLayout>
  )
}

export default ExpertBioProfilePage
